import { Link, useLocation } from 'react-router-dom'
import { Clock, FileSpreadsheet, LogOut, Route, Smartphone } from 'lucide-react'

import { Button } from '@/components/ui/button'
import type { AuthState } from '@/lib/auth'
import { buildAppHref } from '@/lib/auth'

const clientNavItems = [
  { to: '/tt', label: 'Travel Time', icon: Clock },
  { to: '/devices', label: 'Devices', icon: Smartphone },
  { to: '/reports', label: 'Reports', icon: FileSpreadsheet },
]

interface NavbarProps {
  auth: AuthState
  onLogout: () => void
}

export function Navbar({ auth, onLogout }: NavbarProps) {
  const location = useLocation()
  const navItems = clientNavItems
  const homeHref = buildAppHref('/', auth)

  return (
    <nav className="sticky top-0 z-50 border-b border-white/10 bg-[rgb(0,59,61)] text-white">
      <div className="mx-auto flex h-14 max-w-[1200px] items-center px-8">
        <Link to={homeHref} className="mr-8 flex items-center gap-2 text-lg font-bold text-white no-underline transition-opacity hover:opacity-80">
          <Route className="h-5 w-5" />
          <span>BT Travel Time</span>
        </Link>
        <div className="flex items-center gap-1">
          {navItems.map(({ to, label, icon: Icon }) => (
            <Button
              key={to}
              variant="ghost"
              size="sm"
              asChild
              className={location.pathname === to
                ? 'bg-white/20 text-white hover:bg-white/25 hover:text-white'
                : 'text-white/80 hover:bg-white/10 hover:text-white'}
            >
              <Link to={buildAppHref(to, auth)} className="no-underline">
                <Icon className="h-4 w-4" />
                {label}
              </Link>
            </Button>
          ))}
        </div>
        <div className="ml-auto flex items-center gap-2">
          {auth.projectCode ? (
            <span className="hidden rounded-full border border-white/20 bg-white/10 px-2.5 py-1 text-xs font-medium text-white/90 md:inline-flex">
              {auth.projectCode}
            </span>
          ) : null}
          <Button
            variant="ghost"
            size="sm"
            onClick={onLogout}
            className="text-white/80 hover:bg-white/10 hover:text-white"
          >
            <LogOut className="h-4 w-4" />
            Log out
          </Button>
        </div>
      </div>
    </nav>
  )
}
